module.exports = __webpack_public_path__ + "img/coins-stack.217aa270.png";